// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box, Theme, Typography } from "@outschool/backpack";
import { ContentfulMagnetPage } from "@outschool/gql-backend-generated";
import { leaderPath } from "@outschool/routes";
import { DEFAULT_PROFILE_IMAGE } from "@outschool/ui-components-shared";
import { Avatar } from "@outschool/ui-legacy-component-library";
import { useIsMobile, useLinkComponent } from "@outschool/ui-utils";
import React from "react";

import renderOptionsLinks from "../../components/contentful/ContentfulRenderOptions";

export default function BodyMagnetPage({
  magnetPage
}: {
  magnetPage: ContentfulMagnetPage;
}) {
  const Link = useLinkComponent();
  const body = magnetPage.body;
  const author = magnetPage?.author;
  const isLink = author?.isTeacher && author?.uid != null;

  const isMobile = useIsMobile();
  const AuthorSection = () => {
    return (
      <Box
        flex
        sx={{
          alignItems: "center",
          marginY: "30px"
        }}
      >
        <Box
          sx={{
            width: "6%",
            minWidth: "70px"
          }}
        >
          <Avatar
            src={author?.profileImage?.url || DEFAULT_PROFILE_IMAGE}
            alt={author?.name || "author profile image"}
            size={65}
          />
        </Box>
        <Box
          sx={{
            marginLeft: "5px"
          }}
        >
          <Typography
            variant="inherit"
            sx={(theme: Theme) => ({
              color: isLink ? "primary.700" : "common.black",
              textOverflow: "ellipsis",
              fontSize: theme.typography.pxToRem(20),
              marginLeft: "8px",
              display: "block"
            })}
          >
            {author?.name}
          </Typography>
          {author?.description && (
            <Typography
              variant="inherit"
              sx={(theme: Theme) => ({
                color: "common.black",
                textOverflow: "ellipsis",
                fontSize: theme.typography.pxToRem(15),
                marginLeft: "8px",
                display: "block"
              })}
            >
              {author?.description}
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={(theme: Theme) => ({
        "& ul": {
          px: "2em"
        },

        "& ul p, & ol p": {
          my: "0px"
        },

        "& h2, & h3, & h4, & h5, & h6": {
          marginTop: theme.spacing(48),
          marginBottom: theme.spacing(12)
        },

        "& p": {
          lineHeight: theme.spacing(28),
          marginBottom: theme.spacing(36)
        },

        "& blockquote": {
          maxWidth: theme.spacing(500),
          backgroundColor: "#f1f2f3",
          borderRadius: "8px",
          paddingX: theme.spacing(16),
          paddingY: theme.spacing(12),
          marginBottom: theme.spacing(30)
        },

        "& blockquote > p": {
          margin: "0px",
          fontSize: theme.typography.pxToRem(22),
          lineHeight: theme.spacing(32)
        }
      })}
    >
      {documentToReactComponents(
        body?.json,
        body?.links ? renderOptionsLinks(body?.links, isMobile) : {}
      )}

      {isLink ? (
        <Link
          trackingName="magnet_page_author_link"
          to={leaderPath(author?.uid || "")}
        >
          <AuthorSection />
        </Link>
      ) : (
        <AuthorSection />
      )}
    </Box>
  );
}
